module.exports = __webpack_public_path__ + "static/media/madpaws.efda139f.png";